module.exports = __webpack_public_path__ + "static/media/Transit.5ebb7eba.png";